import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {RightBarSection} from '../../section';
import {LibraryTree} from './library-tree/LibraryTree.component';
import {LibraryTreeController} from './library-tree/LibraryTree.controller';
import Translate from '../../../translate/Translate';
import './LibrarySection.scss';

export interface ILibrarySectionController {
    readonly libraryTreeController: LibraryTreeController;
    readonly libraryEnabled: boolean;
    readonly libSectionOpen: boolean;
    readonly libraryIsEmpty: boolean;
    readonly translate: (key: string) => string;
    readonly useNewInterface: boolean;
    toggleLibSection(): void;
}

interface LibrarySectionProps {
    ctrl: ILibrarySectionController;
}

@observer
export class LibrarySection extends TechseeBaseComponent<LibrarySectionProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl.libraryEnabled) {
            return <></>;
        }

        return (
            <RightBarSection
                className='library-section'
                title={ctrl.translate('MAIN.VIEW.LIBRARY')}
                isOpen={ctrl.libSectionOpen}
                onToggle={ctrl.toggleLibSection}
                useNewInterface={ctrl.useNewInterface}>
                <LibraryTree ctrl={ctrl.libraryTreeController} />
                {ctrl.libraryIsEmpty && (
                    <span className='panel-empty'>
                        <Translate text='MAIN.VIEW.LIBRARY.EMPTY' />
                    </span>
                )}
            </RightBarSection>
        );
    }
}
